export const environment = {
  production: false,
  apiBaseUrl: 'https://grandls-api.dsbase.de/api/',
  appVersion: '1.2.3',
};
